/* @flow */

import React from 'react';

export type $TooltipPosition = 'top' | 'bottom';

type $Props = {
  text: string,
  children: React$Node,
  position?: $TooltipPosition
};

const WorkbenchTooltip = ({ text, children, position }: $Props) => (
  <div className="wb-e-tooltip">
    {children}
    <span className={"wb-e-tooltip__text--" + (position || 'top')}>{text}</span>
  </div>
);

export default WorkbenchTooltip;
